<template>
    <div class="guest">
        <div class="guest__content">
            <AppImage
                class="guest__logo"
                :src="require('@/assets/img/upmood-brand.svg')"
            />

			<router-view class="guest__view"></router-view>
        </div>
    </div>
</template>
<script>
export default {
	async mounted () {
		await this.$nextTick()
		this.$emit('mounted')
	}
}
</script>

<style lang="scss" scoped>
.guest {
    height: 100%;
    width: 100%;
    background-image: url('~@/assets/img/guest_bg.png');
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &__content {
        width: 100%;
        max-width: 400px;
    }

    &__logo {
        display: inline-block;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 20px;
        width: 100%;
        height: 140px;
    }

    ::v-deep &__view {
        height: 100%;
        width: 100%;
        color: #fff;

        .header {
            color: #fff;
            margin-bottom: 30px;

            &__title, &__message {
                width: 100%;
                text-align: center;
            }

            &__title { margin-bottom: 10px; }
        }

        .card {
            padding: 10px;
            color: #fff;
            border-radius: 5px;
            margin-bottom: 20px;
            display: flex;
            align-items: center;

            &--error { background-color: $danger; }
            &--success { background-color: $success; }

            p {
                margin-left: 10px;
                font-style: italic;
            }
        }

        .form {
            color: #fff;

            &__input {
                display: block;
                margin-bottom: 20px;
                font-size: 16px;

                ::v-deep .require-mark { display: none; }
            }

            &__link {
                color: #fff;
                margin: 20px 0;
                display: inline-block;
                transition: 0.3s;

                &:hover {
                    text-decoration: underline;
                }
            }

            &__button {
                width: 100%;
                font-size: 16px;
                padding: 10px;
                margin-top: 20px;
                border-color: #fff;
                color: #fff;
                transition: 0.3s;

                &:hover {
                    background-color: $primary;
                    border-color: $primary;
                    opacity: 1;
                }
            }
        }
    }
}
</style>
